import { TableRecord } from '@/models/TableRecord'

export class MedicalClearanceRecord extends TableRecord {
  constructor(personId?: number) {
    super()
    this.personId = personId
  }
  public personId?: number
  public clearanceDate: string | null = null
  public expiration: string | null = null
  public restrictions: string | null = null
  public disposable: boolean = false
  public hfNPR: boolean = false
  public ffNPR: boolean = false
  public hfPAPR: boolean = false
  public ffPAPR: boolean = false
  public hfSAR: boolean = false
  public ffSAR: boolean = false
  public scba: boolean = false
}
